// GENERATED FILE — DO NOT EDIT MANUALLY
// Generated from: public/config/domains/infrastructure-targets.registry.yml
// Run `npm run codegen` to regenerate

export enum InfraTargetEvents {
  LOAD_TARGETS = "load_infra_targets",
  CREATE_TARGET = "create_infra_target",
  UPDATE_TARGET = "update_infra_target",
  DELETE_TARGET = "delete_infra_target",
  TARGETS_LOADED = "infra_targets_loaded",
  TARGET_CREATED = "infra_target_created",
  TARGET_UPDATED = "infra_target_updated",
  TARGET_DELETED = "infra_target_deleted",
  TARGET_ERROR = "infra_target_error",
  TARGET_STATUS_CHANGED = "infra_target_status_changed",
}

export enum InfraTargetEndpoints {
  LIST_TARGETS = "/api/v1/infrastructure-targets",
  GET_TARGET = "/api/v1/infrastructure-targets/:id",
  CREATE_TARGET = "/api/v1/infrastructure-targets",
  UPDATE_TARGET = "/api/v1/infrastructure-targets/:id",
  DELETE_TARGET = "/api/v1/infrastructure-targets/:id",
}
